<template>
  <v-app id="app">
    <Navbar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/navBar/NavBar.vue";

export default {
  name: "App",

  components: {
    Navbar,
  },

  data() {
    return {};
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
